import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextInput from "@shared/v2/TextInput";

const EditTagModal = ({ tag: propTag, onClose, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState(null);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    setErrors(null);
    setTag(propTag);
  }, [propTag]);
  return (
    <Modal
      show={Boolean(tag)}
      onHide={onClose}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title={`${tag?.id ? "Edit" : "Create"} Person Tag`} closeButton />

      {tag && (
        <Modal.Body className="tw-py-[8px] tw-flex tw-flex-col tw-gap-[24px] tw-overflow-auto">
          <TextInput
            label="Tag Name"
            value={tag.name || ""}
            onChange={(e) => {
              const { value } = e.target;
              setTag((t) => ({ ...t, name: value }));
            }}
            error={errors?.name}
          />
        </Modal.Body>
      )}

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button
          isLoading={loading}
          size="medium"
          onClick={() => {
            setErrors(null);
            setLoading(true);
            onSave(tag)
              .catch((err) => setErrors(err?.response.data?.errors))
              .finally(() => {
                setLoading(false);
              });
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EditTagModal.propTypes = {
  tag: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

EditTagModal.defaultProps = {
  tag: null,
};

export default EditTagModal;
